
import kontakt from '~/mixins/models/kontakt';
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [kontakt, formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'formular::betriebe',
        titel: null,
        modelname: 'Betrieb',
        model: 'betriebe'
      },
      model: null
    }
  },
  computed: {},
  watch: {},
  methods: {
    fillModel(model = null) {
      if (!model) model = {};
      let empty = {
        betrieb: 1,
        kontakt: this.$copy(this.emptyKontakt)
      };
      this.model = this.$fillMissing(model, empty);
    },
  },

}
